module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[116]359.34b202b.woff2";